import { request } from "../../base/HTTP";
import HttpMethod from "../../constants/HttpMethod";


export async function generateMainBookOfBuriedReview(data) {
  return await request('/api/report/mainbookofburied', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateMainBookOfCrematedReview(data) {
  return await request('/api/report/mainbookofcremated', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateStoneCuttingWorksReview(data) {
  return await request('/api/report/stoneworks', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateStoneCuttingWorksPermit(id) {
  return await request('/api/report/stoneworks/permit/' + id, {}, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateTransporterByTimesReview(data) {
  return await request('/api/report/transporter', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateFuneralAndUrnPerMonth(data) {
  return await request('/api/report/funeralAndUrnPerMonthForSelectedYear', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateFuneralsForGraveFieldsAndSelectedGraveyard(data) {
  return await request('/api/report/funeralsForGraveFieldsAndSelectedGraveyard', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateFuneralsForAllGraveyards(data) {
  return await request('api/report/funeralsForAllGraveyards', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateFuneralsForGraveFieldsAndGraveyardsPerMonthForSelectedYear(data) {
  return await request('api/report/funeralsForGraveFieldsAndGraveyardsPerMonthForSelectedYear', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateFuneralsForYearsOfBurialAndSelectedGraveyards(data) {
  return await request('api/report/funeralsForYearsOfBurialAndSelectedGraveyards', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateReservationReview(data) {
  return await request('/api/report/reservation', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateReviserReview(data) {
  return await request('/api/report/reviser', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateExpectedIncomeReview(data) {
  return await request('/api/report/expectedIncome', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateExpiryByGraveFIeld(data) {
  return await request('/api/report/expiryByGraveField', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateReportByCauseOfDeath(data) {
  return await request('/api/report/causeOfDeath', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateReportByArrangedPlot(data) {
  return await request('/api/report/arrangedPlot', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateReportByAgeToOneYear(data) {
  return await request('/api/report/ageToOneYear', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateSoldGraveSitesForSelectedYearAndGraveyard(data) {
  return await request('/api/report/reservationsSoldGraveSitesForSelectedYearAndGraveyard', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateSoldGraveSitesForSelectedYearAndGraveyardAndPlot(data) {
  return await request('/api/report/reservationsSoldGraveSitesForSelectedYearAndGraveyardAndPlot', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateInheritedGraveSitesForCurrentYearPerMonths(data) {
  return await request('/api/report/reservationsInheritedGraveSitesForCurrentYearPerMonths', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateInheritedGraveSitesForCurrentYearAndSelectedPlotPerMonths(data) {
  return await request('/api/report/reservationsInheritedGraveSitesForCurrentYearAndSelectedPlotPerMonths', data, HttpMethod.GET, { responseType: 'blob' });
}


/* Reports of specification point 23; every one of them also accepts format=xlsx (point 24). */

export async function generateMonthlyCremationReport(data) {
  return await request('/api/report/cremations/monthly', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateYearlyCremationComparisonReport(data) {
  return await request('/api/report/cremations/yearlyComparison', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateCremationStructureReport(data) {
  return await request('/api/report/cremations/structure', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateCremationAveragesReport(data) {
  return await request('/api/report/cremations/averages', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateBurialBookReport(data) {
  return await request('/api/report/burials/book', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateGksSummaryReport(data) {
  return await request('/api/report/burials/gksSummary', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateTransporterSummaryReport(data) {
  return await request('/api/report/burials/transporters', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateTombSummaryReport(data) {
  return await request('/api/report/burials/tombs', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function generateRenewalSummaryReport(data) {
  return await request('/api/report/renewals/summary', data, HttpMethod.GET, { responseType: 'blob' });
}
